export default __webpack_public_path__ + "static/dispatch-menu-f104a90f3a0b834941d53af3a3538ee5.svg";